import React from "react";
import Badge from "../../../../components/elements/Badge";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const OrganisationReports = () => {
  const { t } = useTranslation();
  const { lang } = useSelector((state) => state?.langProvider);
  const reports = [
    {
      section: t("Sales"),
      description: t(
        "Track sales for your event\nReports may not reconcile with dancebrite payouts if they include financial amounts not collected by Dancebrite, such as cash, <a href='/' target='_blank'>manual</a> or <a href='/' target='_blank'>offline sales</a>."
      ),
      items: [
        {
          title: t("Orders"),
          description: t(
            "Buyer details including a cost breakdown of each order"
          ),
          icon: "fa-light fa-boxes",
          link: `/${lang}/user/reporting/organisation-reports/orders`,
        },
        {
          title: t("Sales Summary"),
          description: t(
            "An overview of all ticket and add-on sales, including fees and taxes, aggregated by event"
          ),
          icon: "fa-light fa-chart-line",
          link: `/${lang}/user/reporting/organisation-reports/sales`,
        },
        // {
        //   title: "Sales Summary",
        //   description:
        //     "An overview of all ticket sales, including fees and taxes",
        //   icon: "fa-light fa-file-chart-column",
        //   link: "",
        // },
        {
          title: t("Sales by ticket type"),
          description: t(
            "An overview of all ticket sales, including fees and taxes"
          ),
          icon: "fa-light fa-file-chart-column",
          link: `/${lang}/user/reporting/organisation-reports/ticket-type`,
        },
        // {
        //   title: "Audit",
        //   description: "Review sold and available seats for your events",
        //   icon: "fa-light fa-money-check-pen",
        //   link: ""
        // },
      ],
    },
    {
      section: t("Attendees"),
      description: t("View details about your attendees"),
      items: [
        {
          title: t("Attendees"),
          description: t(
            "List of each attendee, including their email addresses"
          ),
          icon: "fa-light fa-users",
          link: `/${lang}/user/reporting/organisation-reports/attendees`,
        },
        // {
        //   title: "Add-ons",
        //   description: "List of each attendee who purchased an Add-on",
        //   icon: "fa-light fa-puzzle-piece",
        //   link: ""
        // },
        {
          title: t("Add-ons"),
          description: t("List of each attendee who purchased an Add-on"),
          icon: "fa-light fa-messages-question",
          link: `/${lang}/user/reporting/organisation-reports/add-ons`,
        },
      ],
    },
    // {
    //   section: "Marketing",
    //   description: "View details about sales from marketing features",
    //   items: [
    //     {
    //       title: "Promotion codes",
    //       description: "List of each buyer that purchased using a code",
    //       icon: "fa-light fa-badge-percent",
    //       link: ""
    //     },
    //     {
    //       title: "Tracking links",
    //       description: "List of each buyer that purchased using a tracking link",
    //       icon: "fa-light fa-display-chart-up-circle-dollar",
    //       link: ""
    //     },
    //     {
    //       title: "Traffic and Conversion",
    //       description: "Review how attendees found and bought tickets to your events",
    //       icon: "fa-light fa-chart-user",
    //       link: ""
    //     },
    //   ],
    // },
    // {
    //   section: "Box Office",
    //   description: "Monitor your at-the-door sales",
    //   items: [
    //     {
    //       title: "Box Office Summary",
    //       description: "Monitor your at-the-door event sales",
    //       icon: "fa-light fa-rectangle-history",
    //       link: "",
    //     },
    //     {
    //       title: "Attendance",
    //       description: "See when attendees checked in to your event",
    //       icon: "fa-light fa-screen-users",
    //       link: "",
    //     },
    //     {
    //       title: "Holds Summary",
    //       description: "Check to see which tickets are currently on hold",
    //       icon: "fa-light fa-tickets",
    //       link: "",
    //     },
    //     {
    //       title: "Transfers",
    //       description:
    //         "Review tickets that have been transferred from one attendee to another",
    //       icon: "fa-light fa-right-left-large",
    //       link: "",
    //     },
    //   ],
    // },
  ];

  return (
    <div className="divide-y divide-slate-100">
      {reports.map((section, index) => (
        <div key={index} className="relative py-6 space-y-4">
          <div className="space-y-2 w-full">
            <h2 className="text-2xl text-slate-900 font-bold font-Montserrat">
              {section?.section}
            </h2>
            <div className="text-base text-slate-500 font-Nunito whitespace-pre-wrap leading-snug"></div>
          </div>
          <div className="grid lg:grid-cols-5 gap-4">
            {section.items.map((item, subindex) => (
              <Link
                key={subindex}
                to={item?.link}
                className="group relative shadow rounded-lg cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline"
              >
                <div className="py-6 px-4 flex items-start gap-4">
                  <div className="flex-shrink flex-grow space-y-3">
                    {item?.title && (
                      <h3 className="text-base font-bold text-slate-900 group-hover:text-primary transition-all duration-300 leading-tight">
                        {item?.title}
                      </h3>
                    )}
                    {item?.description && (
                      <div className="text-sm text-slate-500 font-Nunito">
                        {item?.description}
                      </div>
                    )}
                  </div>
                  <div className="flex-shrink-0 flex items-center justify-center w-12 md:w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
                    <i className={item?.icon}></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrganisationReports;
